module.exports = __webpack_public_path__ + "img/sendai.aeabf66b.jpg";